import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-324fd65c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "h-full overflow-auto p-8 w-full h-full flex flex-col" }
const _hoisted_2 = { class: "py-12 flex flex-col justify-center items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-3 font-regular flex flex-wrap justify-center" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Trascina qui i tuoi documenti oppure")
], -1))
const _hoisted_4 = { class: "preview-upload mt-4" }
const _hoisted_5 = {
  key: 0,
  class: "files"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadedDocumentPreview = _resolveComponent("UploadedDocumentPreview")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.modelValue == undefined)
      ? (_openBlock(), _createElementBlock("article", {
          key: 0,
          class: _normalizeClass(["relative h-full flex flex-col bg-white rounded-md border-red-400", { border: _ctx.error }]),
          "aria-label": "File Upload Modal",
          onDragover: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onDragOver && _ctx.onDragOver(...args))),
          onDragleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDragLeave && _ctx.onDragLeave(...args))),
          onOndragenter: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onDragEnter && _ctx.onDragEnter(...args))),
          onDrop: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args)))
        }, [
          _createElementVNode("section", _hoisted_1, [
            _createElementVNode("header", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("input", {
                id: "hidden-input",
                type: "file",
                ref: "file",
                onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
                multiple: ""
              }, null, 544),
              _createElementVNode("button", {
                class: "mt-2 px-3 py-1 bg-gray-200 button hover:bg-gray-300 focus:shadow-outline focus:outline-none",
                id: "button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onUploadClick && _ctx.onUploadClick(...args)))
              }, "Carica file")
            ])
          ])
        ], 34))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.modelValue != undefined)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_UploadedDocumentPreview, {
              class: "preview",
              name: _ctx.modelValue.d.title,
              type: _ctx.modelValue.d.mimeType,
              onDelete: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onDelete()))
            }, null, 8, ["name", "type"])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}